<app-users-listing [enableMainBtn]="true" [titleMainBtn]="'Aggiungi Staff'" [type]="type"
  [linkMainBtn]="'/nuovo-utente'" [linkMainBtnQueryParams]="{type: type}">
</app-users-listing>